import axios from "axios";
const baseURL = "/api";
const http = axios.create({
  // 基地址
  baseURL,
  //   超时时间
  timeout: 5000,
});
// 请求拦截器
http.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
// 响应拦截器
http.interceptors.response.use(
  (res) => {
    // 请求成功，数据失败

    // 完全成功
    return res.data;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export default http;
